
export const formatDate = (isoDate: string): string => {
    const date = new Date(isoDate);
    return new Intl.DateTimeFormat("de-DE", {
        weekday: "long",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }).format(date);
};

export const formatTimeRange = (raw: string): string => {
    const [from, to] = raw.split("-");
    if (!from || !to) {
        return raw;
    }
    return `${from} bis ${to} Uhr`;
};
